import React, {useState, useEffect, useRef, useCallback}from 'react';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import BootstrapTable from 'react-bootstrap-table-next';
import { translate, isEmptyChk } from 'utils/common';
import { TABLE_ACTION_COL_OPTIONS} from 'utils/constants';
import { NoData } from 'common/components';

function Datatable(props){
  // onSelectAll(isSelected){
  //   if (isSelected) {
  //     return this.refs.table.state.data.map(row => row.id);
  //   }
  // } 
  let { tableData, rowSelectEnabled, disableActionCol, customClass, keyField, expandRow, onTableActionClick,  actionColumnHeaderAttrs, actionHeaderClasses= '' } = props;
  keyField = keyField ? keyField : 'id';
  // var columns = [...tableData.columnData, ...getActionColData()]
   
  const [columns, setColumns] = useState([])

  useEffect(()=>{
    function actionColumnFormatter(cellContent, row) {
      if(props.actionColumnFormatter) return props.actionColumnFormatter(cellContent, row)
      let actionColumnItems = !isEmptyChk(tableData.actionColumnItems)?tableData.actionColumnItems : [TABLE_ACTION_COL_OPTIONS.EDIT];
      return <p>
                {
                  actionColumnItems.map((item, indx)=>{
                    return(<a key={"col"+indx} className="bold mr-3" 
                        onClick={() => onTableActionClick({ type:item.type, data:row } )}  >
                        {/* onClick={() => handleEditOptionClick({ [PRODUCT_ID]: row[PRODUCT_ID], [LANG_KEY]: row[LANG_KEY] } )}  > */}
                        <i className={"far mr-2 "+item.icon}></i>{translate(item.label)}
                    </a>)
                  })
                }
            </p>
    }

    function getActionColData(){    
      if(props.actionColumnFormatter 
        || (!disableActionCol)) {  
        // || (!disableActionCol && !isEmptyChk(tableData.actionColumnItems))) {  
            let actionItems=[ { 
                            dataField: 'action', 
                            text: translate('action'),
                            formatter: (cellContent, row) => (
                                actionColumnFormatter(cellContent, row)
                            ),
                            headerClasses: actionHeaderClasses
                          }]
        return actionItems
      }
      return []
    }
    setColumns([...tableData.columnData, ...getActionColData()])

  },[tableData.columnData, tableData.actionColumnItems, disableActionCol, onTableActionClick])

   

  function handleOnSelect(row, selected, rowIndex) { 
    ///When selecting a row, this function wil update parents data with 'selected:true/false' and reload
    // let s= this.refs.table.state.selectedRowKeys
    // if(props.toggleRowSelect) props.toggleRowSelect(row, isSelect);
    let updatedRowData = tableData.rowData.map(item=> { 
      if(item.id == row.id) {
          return {...item, selected:selected} 
      } else return item;
    }) 
    props.updateTableData({...tableData, rowData: updatedRowData})
  }
  function handleOnSelectAll(isSelect, rows, rowIndex) {  
    let updatedRowData = tableData.rowData.map(item=> {  
          return {...item, selected:isSelect}  
    }) 
    props.updateTableData({...tableData, rowData: updatedRowData})
  }


  const selectRow = {
    mode: 'checkbox', 
    selected: tableData.rowData.filter((data) => data.selected).map(item => item.id),//eg:[1,3]    // clickToSelect: true,
    onSelect: handleOnSelect,
    onSelectAll:handleOnSelectAll
    // ...(props.selectRow ? props.selectRow : {
    //   selectionHeaderRenderer: ({ mode, checked, indeterminate }) => (
    //     <span></span>
    //   )
    // })
  };
  const dynamicProps = {
    ...(rowSelectEnabled ? { selectRow } : <span></span>),
    noDataIndication: props.noDataIndication ? props.noDataIndication: undefined
    // ...(expandRow ? { expandRow: expandRow } : {}),
    // ...(this.props.pagination ? { pagination: this.props.pagination } : {})
  }
  function noData() {
    return props.noDataIndicationRequired ? <NoData/> : null;
}
  

  return (
    <div className={"table-common  " + customClass}>
      <div className="custom-table-scroll-wrap">
        {!isEmptyChk(columns) && 
        <BootstrapTable  //ref='table' 
          keyField={keyField} 
              data={tableData.rowData} columns={columns}
          {...dynamicProps}
          noDataIndication={() => noData()} 
        />}
      </div>
    </div>
  );
}

export default Datatable;


    
    // var actionCol = this.props.disableActionCol ? [] : [
    //   {
    //     dataField: 'action', text: translate('action'),
    //     formatter: (cellContent, row) => (
    //       actionColumnFormatter ? actionColumnFormatter(cellContent, row) : <a href="#">{translate('Edit')}</a>
    //     ),
    //     ...(actionColumnHeaderAttrs?{headerAttrs:actionColumnHeaderAttrs}:{})
    //   }
    // ]
 

// Specifies the default values for props: 
// Datatable.defaultProps = {
//   columnData: [{ dataField: 'id', text: 'Product ID' },
//   { dataField: 'name', text: 'Product Name' },
//   { dataField: 'price', text: 'Product Price' }],
//   rowData: [{ 'id': 1, 'name': "sample data", 'price': 1234 },
//   { 'id': 2, 'name': "sample data", 'price': 12346788 }],
//   rowSelectEnabled: false
// };

